import { useState } from "react";
import { useHistory } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";
import useInitPage from "../../../utils/initPage";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";

import Template from "../../../template/template";
import Input from "../../../components/form/input";
import Notify from "../../../components/notification/notify";

function Recovery() {
  useInitPage({
    title: t("Recovery.Title"),
  });

  const { ApiRecovery } = useApi();

  const { push } = useHistory();

  const [form, setForm] = useState({});

  function handleInputChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function RecoverySubmit(e) {
    e.preventDefault();

    if (!form.login) return Notify({ type: "danger", message: t("Errors.EmptyLogin") });

    const { data } = await ApiRecovery(form);

    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    Notify({ type: "success", message: t("Success.RecoverySended") });

    return push(DefRoutes.Home);
  }

  return (
    <Template>
      <div className="section-form">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="user-form-box">
                <h1>{t("Recovery.Recovery")}</h1>
                <p>{t("Recovery.Description")}</p>
                <form onSubmit={RecoverySubmit}>
                  <Input
                    label={t("SignIn.Form.User")}
                    name="login"
                    value={form.login || ""}
                    onChange={handleInputChange}
                  />

                  <div className="button-conform">
                    <button type="submit" className="img-btn btn-confirmar">
                      {t("SignIn.Form.Submit")}
                    </button>
                  </div>

                  <div className="submit-btn">
                    <button type="button" className="btn-regester" onClick={() => push(DefRoutes.SignIn)}>
                      {t("Recovery.SignIn")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default Recovery;
